import { render, staticRenderFns } from "./BaseSelection.vue?vue&type=template&id=3b6b291f&scoped=true&"
import script from "./BaseSelection.vue?vue&type=script&lang=js&"
export * from "./BaseSelection.vue?vue&type=script&lang=js&"
import style0 from "./BaseSelection.vue?vue&type=style&index=0&id=3b6b291f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6b291f",
  null
  
)

export default component.exports